import { ContentPlayer } from "@/components/player/content-player"
import type { PlayableItem } from "@/lib/player/playable-item"
import { cn } from "@/lib/utils"

/**
 * The seated well for unstyleable audio embeds (§6.0): the jacket chrome
 * persists around it and the embed is the record — a small, framed element,
 * never a bare 1/1 iframe floating in dead space. Spotify ships no bridge,
 * so the embed mounts fresh here at threshold (never in ambient) and
 * playback starts on the embed's own play button — the two-tap flow is
 * native Spotify behavior, acknowledged rather than fought.
 *
 * `data-embed-well` keeps Embla's drag out (see jacketEmblaOpts). The
 * `active` mount arms LiveIframe's duration-timer fallback, so seeded
 * durations still reach Up Next (wall-clock — noted degradation).
 */
export function AudioWell({
  item,
  height = 152,
  className,
}: {
  item: PlayableItem
  /** 152 = Spotify's compact card; 352 = the full cover-art card (B). */
  height?: 152 | 352
  className?: string
}) {
  return (
    <div
      data-embed-well
      className={cn(
        "bg-surface-elevated overflow-hidden rounded-xs shadow-xs",
        className,
      )}
      style={{ height }}
    >
      <ContentPlayer
        item={item}
        mode="live"
        active
        muted={false}
        className="aspect-auto h-full w-full rounded-none"
      />
    </div>
  )
}
